import { useSelector } from "react-redux";
import AuthRouter from "./AuthRouter";
import AdminRouter from "./AdminRouter";

export default function AllRoutes() {
    const user = useSelector((state) => state?.auth)
    return (
        (
            user?.isLoggedIn ? (
                <AdminRouter />
            ) : (
                <AuthRouter />
            )
        )
    )
}